import { Trans, useTranslation } from 'react-i18next';
import environment from '@environment';

/**
 * Translations for setting up a recurring payment.
 */
const useSetupTranslations = () => {
  const { t } = useTranslation();

  const key = (translationKey: string) => `account.recurringPayment.setup.${translationKey}`;
  const setup = (translationKey: string) => t(key(translationKey));
  const confirmation = (translationKey: string) => setup(`confirmation.${translationKey}`);
  const failure = (translationKey: string) => setup(`failure.${translationKey}`);

  const termsLabel = () => {
    const url = environment.URLS.RECURRING_PAYMENT.TERMS_AND_CONDITIONS;

    return <Trans
      i18nKey={key('termsLabel')}
      defaults="I accept the <a>Terms of Service and Privacy Policy</a>"
      components={{
        a: <a href={url} target="_blank" rel="noreferrer"></a>,
      }}
    />;
  };

  const scheduledPaymentDateText = (ordinal: string) => {
    return <Trans
      i18nKey={key('scheduledPaymentDateText')}
      defaults={"Your recurring payment is scheduled for the<br/><strong>{{ordinal}} of every month</strong>."}
      values={{ ordinal }}
      components={{ bold: <strong></strong>, br: <br/> }}
    />
  };

  const nominalChargeAmountText = (amount: string) => {
    return <Trans
      i18nKey={key('nominalChargeAmount')}
      defaults={"A small charge of {{amount}} will be deducted to verify your card and credited to your DStv account once the setup is complete."}
      values={{ amount }}
    />
  };

  return {
    key,
    setup,
    heading: setup('heading'),
    text: setup('text'),
    setupHeading: setup('setupHeading'),
    setupText: setup('setupText'),
    beforeHeading: setup('beforeYouContinueHeading'),
    chooseBillingDate: setup('chooseBillingDate'),
    checkBankCard: setup('checkBankCard'),
    checkFunds: setup('checkFunds'),
    checkCvv: setup('checkCvv'),
    cancelAnytime: setup('cancelAnytime'),
    termsLabel: termsLabel(),
    setupRecurringPayment: setup('setupRecurringPayment'),
    scheduledPaymentDateText,
    changeDateAfterSetup: setup('changeDateAfterSetup'),
    nominalChargeAmountText,
    addCard: setup('addCard'),
    confirmation: {
      heading: confirmation('heading'),
      nextPayment: confirmation('nextPayment'),
      provider: confirmation('provider'),
      frequency: confirmation('frequency'),
      needToChangePaymentDate: confirmation('needToChangePaymentDate'),
    },
    failure: {
      heading: failure('heading'),
      text: failure('text'),
    },
  };
}

export default useSetupTranslations;